import { ModuleSettingsStore } from "../../../../utils/contentstack/moduleSettingsStore.js";
function getLinkListEntryId(properties) {
  let linkListId = void 0;
  for (const index in properties) {
    if (properties[index]["linkListReferenceUUID"] !== void 0) {
      linkListId = properties[index]["linkListReferenceUUID"];
    }
  }
  return linkListId;
}
function getAriaLabel(moduleSettings, title) {
  const ms = new ModuleSettingsStore({
    composable_window: [],
    key_value: moduleSettings.key_value
  });
  return [
    title,
    ms.getKeyValueItem("arialabel"),
    ms.getKeyValueItem("ariadescribedbytext")
  ].filter((elem) => !!elem).join(", ");
}
export {
  getAriaLabel,
  getLinkListEntryId
};
